import React, { useEffect, useState } from "react";
import { Trans, useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import { useFormik } from "formik";
import {
  Row,
  Col,
  Form,
  Input,
  Button,
  Container,
  Card,
  CardTitle,
  CardBody,
  InputGroup,
  InputGroupAddon,
  InputGroupText,
  Label,
  Spinner,
} from "reactstrap";
import Map from "components/map/index";
import ReCAPTCHA from "react-google-recaptcha";
import {
  COINNIK_MARKER_INSTAGRAM,
  COINNIK_MARKER_LINKDIN,
  COINNIK_MARKER_TWITTER,
  SITE_KEY_VALUE,
} from "configs/constants";
import {
  CONTACT_US_INITIAL_VALUE,
  CONTACT_US_VALIDATION_SHEMA,
} from "fixtureData/formikValidation";
import ValidationError from "components/validationError";
import StaticHeaderInfo from "components/pages/web/static/staticHeaderInfo";
import { contactUs } from "services/api";
import CoinButton from "components/button";
import "assets/styles/components/form.scss";

export default function ContactUs() {
  const [captcha, setCaptcha] = useState("");
  const [captchaError, setCaptchaError] = useState(false);

  const [isLoading, setIsLoading] = useState(false);

  const { t } = useTranslation();

  const CardContentData = [
    { name: "Email : info@coinnik.market", icon: "icon-mail icon-mail-orange" },
    {
      name: "Contact number : 021 47612345",
      icon: "icon-phone icon-phone-orange",
    },
    {
      name: "Unit 1, Diplomat Building, Ayatollah Kashani St, Tehran",
      icon: "icon-location",
    },
  ];

  const formik = useFormik({
    initialValues: CONTACT_US_INITIAL_VALUE,
    validationSchema: CONTACT_US_VALIDATION_SHEMA,
    onSubmit: async (values) => {
      const { name: firstname, contactNumber: mobile, message } = values;
      const lastname = "";
      try {
        if (captcha === null || captcha === "") {
          setCaptchaError(!captchaError);
        } else {
          setIsLoading(true);
          const data = await contactUs({
            "g-recaptcha-response": captcha,
            message,
            firstname,
            lastname,
            mobile,
          });
          if (data) {
            setIsLoading(false);
          }
        }
      } catch (e) {
        setIsLoading(false);
        alert(e);
      }
    },
  });
  const { errors, touched } = formik;

  function onChange(value: any) {
    setCaptcha(value);
  }
  return (
    <div>
      <StaticHeaderInfo>
        <div className="mt-n6 mt-sm-0">
          <span className="text-light fs-2 fw-bold ">
            {t("Contact coinnik Market")}
          </span>
        </div>
      </StaticHeaderInfo>
      <Container className="pt-3">
        <Row>
          <Col
            xs="12"
            sm="12"
            lg="7"
            xl="7"
            className="col-top  mt-n5 mt-lg-0 mb-3 mb-lg-0"
          >
            <Card className="shadow-sm border-radius-1 contact-card-support">
              <CardBody>
                <CardTitle className="pb-2">
                  <span className="title-bordre-bottom  fw-bold fs-5 text-secondary-two-light ">
                    {t("Real 7/24 support")}
                  </span>
                </CardTitle>
                <span className="text-secondary-two-light fs-6">
                  {t("Support_description_first")}
                </span>
                <br />
                <span className="text-secondary-two-light fs-6">
                  {t("Support_description")}
                </span>
                <br />
                <span className="text-secondary-two-light fs-6">
                  <Trans i18nKey="Support_description_second">
                    You can also read the{" "}
                    <Link
                      to="#"
                      className="text-info-one-light text-border-bottom"
                    >
                      FAQ
                    </Link>{" "}
                    and user{" "}
                    <Link to="#" className="text-info-one-light">
                      guide
                    </Link>{" "}
                    before contacting us.
                  </Trans>
                </span>

                <div className="my-3">
                  {CardContentData.map((item: any) => (
                    <CardContent name={t(item.name)} icon={item.icon} />
                  ))}
                </div>

                <Row className="pt-5">
                  <Col
                    xs="12"
                    md="8"
                    xl="5"
                    className="d-flex  align-items-center"
                  >
                    <span className="text-secondary-two-light fs-6">
                      {t("Follow us on social media:")}
                    </span>
                  </Col>
                  <Col
                    xs="12"
                    md="4"
                    xl="3"
                    className="pt-4 pt-sm-0 d-flex align-items-center justify-content-around"
                  >
                    <a href={COINNIK_MARKER_LINKDIN}>
                      <i className="icon-linkdin bg-warning-one p-2 border-radius-2" />
                    </a>
                    <a href={COINNIK_MARKER_INSTAGRAM}>
                      <i className="icon-instagram bg-warning-one p-2 border-radius-2" />
                    </a>
                    <a href={COINNIK_MARKER_TWITTER}>
                      <i className="icon-twitter bg-warning-one p-2 border-radius-2" />
                    </a>
                  </Col>
                </Row>
              </CardBody>
            </Card>
          </Col>
          <Col xs="12" lg="5" xl="5" className="contact-form-view  mt-md-n7 ">
            <Card className="border-radius-1 shadow-sm h-100">
              <CardBody>
                <CardTitle className="pb-4">
                  <span className="title-bordre-bottom fw-bold fs-5 text-secondary-two-light">
                    {t("Comment submission form")}
                  </span>
                </CardTitle>
                <Form
                  onSubmit={formik.handleSubmit}
                  className="form-style d-flex flex-column justify-content-evenly "
                >
                  <div>
                    <Row>
                      <InputGroup className="">
                        <Col xs="12" xl="12" className="d-flex">
                          <InputGroupAddon addonType="prepend">
                            <InputGroupText className="border-radius-tr-1 border-radius-br-1">
                              <i className={"icon-person icon-person-gray"} />
                            </InputGroupText>
                          </InputGroupAddon>
                          <div className="form-floating ">
                            <Input
                              type="text"
                              id={"name"}
                              placeholder={t("first name and last name")}
                              className="border-radius-tl-1 border-radius-bl-1"
                              {...formik.getFieldProps("name")}
                            />
                            <Label for={"name"}>
                              {t("first name and last name")}
                            </Label>
                          </div>
                        </Col>
                        <ValidationError
                          errors={errors}
                          touched={touched}
                          field="name"
                        >
                          {" "}
                          {errors.name}{" "}
                        </ValidationError>
                      </InputGroup>
                    </Row>
                    <Row>
                      <InputGroup className="">
                        <Col xs="12" xl="12" className="d-flex">
                          <InputGroupAddon addonType="prepend">
                            <InputGroupText className="border-radius-tr-1 border-radius-br-1">
                              <i className={"icon-phone icon-phone-gray"} />
                            </InputGroupText>
                          </InputGroupAddon>
                          <div className="form-floating ">
                            <Input
                              type="text"
                              id={"contactNumber"}
                              placeholder={t("first name and last name")}
                              className="border-radius-tl-1 border-radius-bl-1"
                              {...formik.getFieldProps("contactNumber")}
                            />
                            <Label for={"contactNumber"}>
                              {t("Contact number")}
                            </Label>
                          </div>
                        </Col>
                        <ValidationError
                          errors={errors}
                          touched={touched}
                          field="contactNumber"
                        >
                          {" "}
                          {errors.contactNumber}{" "}
                        </ValidationError>
                      </InputGroup>
                    </Row>

                    <InputGroup className="border-radius-tr-1 border-radius-br-1 ">
                      <div className="form-floating ">
                        <textarea
                          className="form-control "
                          placeholder={t("The message you have for us")}
                          id="message"
                          {...formik.getFieldProps("message")}
                        ></textarea>
                        <Label for="message">
                          {t("The message you have for us")}
                        </Label>
                      </div>
                    </InputGroup>
                    <ValidationError
                      errors={errors}
                      touched={touched}
                      field="message"
                    >
                      {" "}
                      {errors.message}{" "}
                    </ValidationError>
                  </div>

                  <div className="d-flex flex-column align-items-center  justify-content-centerpt-2 pt-2 pb-4">
                    <ReCAPTCHA sitekey={SITE_KEY_VALUE} onChange={onChange} />
                    <ValidationError>
                      {captchaError ? "please select captcha" : ""}
                    </ValidationError>
                  </div>

                  <CoinButton
                    onClick={() => formik.handleSubmit()}
                    size="md"
                    color="warning"
                    disabled={isLoading}
                  >
                    {t("Post a comment")}
                  </CoinButton>
                </Form>
              </CardBody>
            </Card>
          </Col>
        </Row>

        <Row className="pt-4">
          <Col xs="12">
            <Map />
          </Col>
        </Row>
      </Container>
    </div>
  );
}

const CardContent = ({ name, icon }: any) => (
  <div className="d-flex justify-content-start align-items-center py-2">
    <i className={icon} />
    <span className="d-inline px-2 text-secondary-two-light fs-6">{name}</span>
  </div>
);
